import {Card, Carousel, Row} from "antd";
import { styled } from "styled-components";

export const StyledCarousel = styled(Carousel)`
    border-radius: 10px;
`;
